import React, { useState, useContext } from 'react';
import { Button, Typography } from 'antd';
// import './comments_.less';
import { SendOutlined, CommentOutlined } from '@ant-design/icons';
import TextEditorReadOnly from '../../text/TextEditorReadOnly';
import TextEditor from '../../text/TextEditor';
import { appContext } from '../../../AppContext';

export default function CommentForm({
  onSubmit: propsOnSubmit,
  isLoading: propsIsLoading,
  size: propsSize,
  content: propsContent,
  avatar: propsAvatar,
  // className: propsClassName,
  // setContent: propsSetContent,
  isActive: propsIsActive,
  cancel: propsCancel,
  commentBoxMode: propsCommentBoxMode,
  placeholder: propsPlaceholder,
  editMode:propsEditMode
}) {
  const [disabled, setDisabled] = useState(true);
  const [textEditorActive, setTextEditorActive] = useState(propsIsActive || false);
  const [content, setContent] = useState();
  const [resetKey, setResetKey] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  
  const [appState] = useContext(appContext);


  const delay = (ms) => new Promise((resolve, reject) => setTimeout(() => resolve(), ms));

  async function handleSubmit(slOnly) {
    setIsLoading(true);
    let json = JSON.stringify(content);
    let test = slOnly;

    let isSuccess = false;
    // eslint-disable-next-line
    const [delayResult, submitSuccess] = await Promise.all([
      delay(500),
      (isSuccess = propsOnSubmit(undefined, json, test)),
    ]);

    if (isSuccess) {
      setResetKey((value) => value + 1);
      setContent();
      setIsLoading(false);
      setTextEditorActive(false);
      setDisabled(true);
    }
    setIsLoading(false);
  }

  function handleChangeTextEditor(newContent) {
    setContent(newContent);
    setDisabled(false);
  }

  function handleEditClickUnsaved() {
    if (content !== '') {
      setTextEditorActive(true);
      return;
    }
    return;
  }

  function handleCancel() {
    if (propsCancel) {
      propsCancel();
      return;
    }
    setContent();
    setDisabled(true);
    setTextEditorActive(false);
    return;
  }

  return (
    <>
      <section className="text-editor-controls">
        {!textEditorActive ? (
          propsCommentBoxMode ? (
            <>
              <div className="comment-box">
                {/* <Avatar name={propsAvatar} /> */}
                <div
                  className="ant-input"
                  style={{ height: 32, width: '100%' }}
                  onClick={() => setTextEditorActive(true)}
                >
                  <>
                    {content ? (
                      <TextEditorReadOnly className="comment-form-readOnly" content={content} />
                    ) : (
                      <span style={{ display: 'flex', alignItems: 'center' }}>
                        <CommentOutlined style={{ marginRight: 8 }} />
                        <Typography.Text type="secondary">{propsPlaceholder}</Typography.Text>
                      </span>
                    )}
                  </>
                </div>
              </div>
            </>
          ) : (
            !textEditorActive && (
              <>
                <TextEditorReadOnly
                  className="comment-form-readOnly"
                  content={content || propsContent}
                  onClick={handleEditClickUnsaved}
                />
                {content && (
                  <div
                    style={{
                      display: 'flex',
                      marginTop: 16,
                    }}
                  >
                    <Button
                      type="secondary"
                      size={propsSize}
                      htmlType="submit"
                      loading={propsIsLoading}
                      onClick={propsCancel}
                      style={{
                        marginRight: 16,
                      }}
                    >
                      {"Cancel"}
                    </Button>
                    <Button
                      type="primary"
                      size={propsSize}
                      htmlType="submit"
                      loading={propsIsLoading}
                      onClick={() => handleSubmit(false)}
                      disabled={disabled}
                      icon={<SendOutlined />}
                    >
                      {"Post"}
                    </Button>

                    {appState.isSlOfStory && !propsEditMode && <Button
                      type="secondary"
                      size={propsSize}
                      // htmlType="submit"
                      loading={propsIsLoading}
                      onClick={() => handleSubmit(true)}
                      disabled={disabled}
                      icon={<SendOutlined />}
                    >
                      {"Only SL Post"}
                    </Button>}
                  </div>
                )}
              </>
            )
          )
        ) : (
          <>
            <TextEditor
              content={content || propsContent}
              onChange={handleChangeTextEditor}
              key={resetKey}
              onClickBlur={() => setTextEditorActive(false)}
            />

            <div
              style={{
                display: 'flex',
                marginTop: 16,
              }}
            >
              <Button
                type="secondary"
                size={propsSize}
                // htmlType="submit"
                loading={propsIsLoading}
                onClick={handleCancel}
                style={{
                  marginRight: 16,
                }}
              >
                {"Cancel"}
              </Button>
              <Button
                type="primary"
                size={propsSize}
                htmlType="submit"
                loading={isLoading || propsIsLoading}
                onClick={() => handleSubmit(false)}
                disabled={disabled}
                icon={<SendOutlined />}
              >
                Post
              </Button>

              {appState.isSlOfStory && !propsEditMode && <Button
                  type="secondary"
                  size={propsSize}
                  // htmlType="submit"
                  loading={propsIsLoading}
                  onClick={() => handleSubmit(true)}
                  disabled={disabled}
                  icon={<SendOutlined />}
                >
                  {"Only SL Post"}
              </Button>}
            </div>
          </>
        )}
      </section>
    </>
  );
}
